import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { FirebaseAuthProvider } from "./Hooks/FirebaseAuth";
import { GoogleAnalyticsContextProvider } from "./Hooks/GoogleAnalyticsContext";
import { ShowEmailFormContextProvider } from "./Hooks/ShowEmailFormContext";
import RouterEntry from "./RouterEntry";
import { Toaster } from "react-hot-toast";
import { YippityUserProvider } from "./Hooks/YippityUserContext";
import { HelmetProvider } from "react-helmet-async";

const App: React.FC = () => {
  return (
    <Router>
      <HelmetProvider>
        <FirebaseAuthProvider>
          <YippityUserProvider>
            <Toaster
              toastOptions={{
                style: {
                  fontSize: "12px",
                },
              }}
            />
            <ShowEmailFormContextProvider>
              <GoogleAnalyticsContextProvider>
                <RouterEntry />
              </GoogleAnalyticsContextProvider>
            </ShowEmailFormContextProvider>
          </YippityUserProvider>
        </FirebaseAuthProvider>
      </HelmetProvider>
    </Router>
  );
};

export default App;
